import React, {useEffect, useRef, useState} from 'react';


import Box from "@mui/material/Box";
import {InputLabel, Select, Stack, TextField} from "@mui/material";
import Button from "@mui/material/Button";
import {Controller, useForm} from "react-hook-form";


import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import {useDispatch, useSelector} from "react-redux";
import {
    getFinancialCodes,
    getGenres, getInitialMarkets,
    getM4mktGroups,
    getProducers,
    getProductionTypes
} from "./ProductClient";
import {changeProduct} from "./productSlice";
import {changeProductSearch} from "./productSearchSlice";
import {getDataPointValueByDataPointId} from "../../DataPointValue/DataPointValueClient";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import DynamicCdpvValueField from "../../CommonComponents/DynamicCdpvValueField";
import FormDatePicker from "../../CommonComponents/FormDatePicker";
import CircularProgressOverlay from "../../CommonComponents/CircularProgressOverlay";




export default function ProductSearch({gridClear}) {

    const selectorSubmitting = useSelector((state) => state.externalDataSlc.value.submitting);

    // const {register, handleSubmit} = useForm();
    const { register, handleSubmit, setValue, reset, control } = useForm();
    // const { register, handleSubmit, setValue, watch, control } = useForm();
    const [m4mktGroupDropdown, setM4mktGroupDropdown] = useState([]);
    const [selectedM4mktGroup, setSelectedM4mktGroup] = useState('');
    const [initialMarketDropdown, setInitialMarketDropdown] = useState([]);
    const [selectedInitialMarket, setSelectedInitialMarket] = useState('');
    const [genreDropdown, setGenreDropdown] = useState([]);
    const [selectedGenre, setSelectedGenre] = useState('');
    const [productionTypeDropdown, setProductionTypeDropdown] = useState([]);
    const [selectedProductionType, setSelectedProductionType] = useState('');
    const [producerDropdown, setProducerDropdown] = useState([]);
    const [selectedProducer, setSelectedProducer] = useState('');
    const [financialCodeDropdown, setFinancialCodeDropdown] = useState([]);
    const [selectedFinancialCode, setSelectedFinancialCode] = useState('');
    const setupsDropdown = ["","Has","None"];
    const [selectedParticipations, setSelectedParticipations] = useState('');
    const [selectedResiduals, setSelectedResiduals] = useState('');
    const [selectedRoyalties, setSelectedRoyalties] = useState('');
    const [r2mDropdown, setR2mDropdown] = useState([]);
    const [productValue, setProductValue] = useState([]);
    const [guildValue, setGuildValue] = useState([]);
    const [r2mValue, setR2mValue] = useState([]);
    const dispatchData = useDispatch();
    const [products, setProducts] = useState([]);
    const [coveredProductDropdown, setCoveredProductDropdown] = useState([]);
    const [selectedCoveredProduct, setSelectedCoveredProduct] = useState([]);
    const selectorDataPointId = 6095;

    const handleClearClick = () => {
        setProductValue("");
    };

    const handleClearProductClick = () => {
        setProductValue("");
    };

    const fetchM4mktGroups = () =>
        getM4mktGroups()

            .then(data => {
                console.log("M4Mkt Groups");
                console.log(data);
                console.log("M4Mkt Groups with empty string");
                data.unshift({singleField: ''});
                console.log(data);
                setM4mktGroupDropdown(data);
            })

    const fetchInitialMarkets = () => {
        getInitialMarkets()

            .then(data => {
                console.log("Initial Markets");
                console.log(data);
                console.log("Initial Markets with empty string");
                data.unshift({singleField: ''});
                console.log(data);
                setInitialMarketDropdown(data);
            })}


    const fetchGenres = () =>
        getGenres()

            .then(data => {
                console.log("Genres");
                console.log(data);
                console.log("Genres with empty string");
                data.unshift({singleField: ''});
                console.log(data);
                setGenreDropdown(data);
            })

    const fetchProductionTypes = () =>
        getProductionTypes()

            .then(data => {
                console.log("Production Types");
                console.log(data);
                console.log("Production Types with empty string");
                data.unshift({singleField: ''});
                console.log(data);
                setProductionTypeDropdown(data);
            })


    const fetchProducers = () =>
        getProducers()

            .then(data => {
                console.log("Producers");
                console.log(data);
                console.log("Producers with empty string");
                data.unshift({singleField: ''});
                console.log(data);
                setProducerDropdown(data);
            })


    const fetchFinancialCodes = () =>
        getFinancialCodes()
            .then(data => {
                console.log("Financial Codes");
                console.log(data);
                console.log("Financial Codes with empty string");
                data.unshift({singleField: ''});
                console.log(data);
                setFinancialCodeDropdown(data);
            })


    const fetchCoveredProducts = () =>
        getDataPointValueByDataPointId(6095)
            .then(data => {
                console.log("Data Point Values");
                console.log(data);
                setCoveredProductDropdown(data);
            });

    useEffect(() => {
        console.log("This is for the M4mkt Group dropdown...");
        fetchM4mktGroups();
        fetchInitialMarkets();
        fetchGenres();
        fetchProductionTypes();
        fetchProducers();
        fetchFinancialCodes();
        fetchCoveredProducts();
    }, []);


    function onSubmit(data) {
        console.log("here's my product search data before I submit it ")
        console.log({data});
        dispatchData(changeProductSearch({
           // searchData: data
            eidr: data.eidr,
            coveredProduct: data.coveredProduct,
            episodeName: data.episodeName,
            externalId: data.externalId,
            financialCode: data.financialCode,
            genre: data.genre,
            initMkt: data.initMkt,
            m4mktGroup: data.m4mktGroup,
            producer: data.producer,
            productionType: data.productionType,
            name: data.name,
            photoStartDateFrom: data.photoStartDateFrom,
            photoStartDateTo: data.photoStartDateTo,
            seasonExternalId: data.seasonExternalId,
            seriesExternalId: data.seriesExternalId,
            seasonName: data.seasonName,
            seriesName: data.seriesName,
            seasonNumberFrom: data.seasonNumberFrom,
            seasonNumberTo: data.seasonNumberTo,
            participations: data.participations,
            residuals: data.residuals,
            royalties: data.royalties
        }));
        dispatchData(changeProduct({
            productGridRefresh: true
        }));
    };


    const handleClear = () => {

        reset({
            eidr: '',
            coveredProduct: '',
            episodeName: '',
            externalId: '',
            financialCode: '',
            genre: '',
            initMkt: '',
            m4mktGroup: '',
            producer: '',
            productionType: '',
            name: '',
            photoStartDateFrom: '',
            photoStartDateTo: '',
            seasonExternalId: '',
            seriesExternalId: '',
            seasonName: '',
            seriesName: '',
            seasonNumberFrom: '',
            seasonNumberTo: '',
            participations: '',
            residuals: '',
            royalties: ''
        });

        setSelectedM4mktGroup('');
        setSelectedInitialMarket('');
        setSelectedGenre('');
        setSelectedProductionType('');
        setSelectedCoveredProduct('');
        setSelectedProducer('');
        setSelectedFinancialCode('');
        setSelectedParticipations('');
        setSelectedResiduals('');
        setSelectedRoyalties('');

        gridClear()
    };


    const handleM4mktGroupChange = (m4mktGroupEvent) => {
        setSelectedM4mktGroup(m4mktGroupEvent.target.value);
        console.log("This is for the selected Value");
        console.log(m4mktGroupEvent.target.value);
    };

    const handleInitialMarketChange = (initialMarketEvent) => {
        setSelectedInitialMarket(initialMarketEvent.target.value);
        setValue('initMkt', initialMarketEvent.target.value);
        console.log("This is for the selected Value");
        console.log(initialMarketEvent.target.value);
    };

    const handleGenreChange = (genreEvent) => {
        setSelectedGenre(genreEvent.target.value);
        console.log("This is for the selected Value");
        console.log(genreEvent.target.value);
    };

    const handleProductionTypeChange = (productionTypeEvent) => {
        setSelectedProductionType(productionTypeEvent.target.value);
        console.log("This is for the selected Value");
        console.log(productionTypeEvent.target.value);
    };

    const handleProducerChange = (producerEvent) => {
        setSelectedProducer(producerEvent.target.value);
        console.log("This is for the selected Value");
        console.log(producerEvent.target.value);
    };

    const handleCoveredProductChange = (coveredProductEvent) => {
        setSelectedCoveredProduct(coveredProductEvent.target.value);
        console.log("This is for the selected Value");
        console.log(coveredProductEvent.target.value);
    };

    const handleFinancialCodeChange = (financialCodeEvent) => {
        setSelectedFinancialCode(financialCodeEvent.target.value);
        console.log("This is for the selected Value");
        console.log(financialCodeEvent.target.value);
    };

    const handleParticipationsChange = (participationsEvent) => {
        setSelectedParticipations(participationsEvent.target.value);
        console.log("This is for the selected Value");
        console.log(participationsEvent.target.value);
    };

    const handleResidualsChange = (residualsEvent) => {
        setSelectedResiduals(residualsEvent.target.value);
        console.log("This is for the selected Value");
        console.log(residualsEvent.target.value);
    };

    const handleRoyaltiesChange = (royaltiesEvent) => {
        setSelectedRoyalties(royaltiesEvent.target.value);
        console.log("This is for the selected Value");
        console.log(royaltiesEvent.target.value);
    };
    const handleClearM4mktGroup = () => {
        setSelectedM4mktGroup("");}


        const selectR2mRef = useRef();

    const onClear = () => {
    };

    const searchForm  = () => (
        <form
            onSubmit={handleSubmit((data)=>        onSubmit(data))}
        >
            <Box
                sx={{  height: 280, pl: 5}}
                role="presentation"
            >
                <Stack direction={"Horizontal"} sx={{ pb: 1 }}>

                <TextField variant="filled"
                    {...register('externalId', { required: false })}
                    id="externalId"   name="externalId"  label="Product ID" aria-describedby="externalId_entry"
                    sx={{ width: 150, pr: 5 }} />
                <TextField variant="filled"
                    {...register('name', { required: false })}
                    id="name"   name="name"  label="Product Name" aria-describedby="name_entry"
                    sx={{ width: 400, pr: 5 }} />
                <TextField variant="filled"
                    {...register('episodeName', { required: false })}
                    id="episodeName"   name="episodeName"  label="Episode Name" aria-describedby="episodeName_entry"
                    sx={{ width: 400, pr: 5  }} />
                    <FormDatePicker
                        name="photoStartDateFrom"
                        label="Photo From"
                        control={control}
                        width={200}
                    />
                    <FormDatePicker
                        name="photoStartDateTo"
                        label="Photo To"
                        control={control}
                        width={200}
                    />
                    {/*<TextField variant="filled"*/}
                    {/*           {...register('photoStartDateFrom', { required: false })}*/}
                    {/*           id="photoStartDateFrom"   name="photoStartDateFrom"  label="Photo From" aria-describedby="photoStartDateFrom_entry"*/}
                    {/*           sx={{ width: 150, pr: 5 }} />*/}
                    {/*<TextField variant="filled"*/}
                    {/*           {...register('photoStartDateTo', { required: false })}*/}
                    {/*           id="photoStartDateTo"   name="photoStartDateTo"  label="Photo To" aria-describedby="photoStartDateTo_entry"*/}
                    {/*           sx={{ width: 150, pr: 5 }} />*/}
                </Stack>
                <Stack direction={"horizontal"}  sx={{ pb: 1 }}>
                    <TextField variant="filled"
                        {...register('seriesExternalId', { required: false })}
                        id="seriesExternalId"   name="seriesExternalId"  label="Series ID" aria-describedby="seriesExternalId_entry"
                        sx={{ width:150, pr: 5 }} />
                    <TextField variant="filled"
                        {...register('seriesName', { required: false })}
                        id="seriesName"   name="seriesName"  label="Series Name" aria-describedby="seriesName_entry"
                        sx={{ width: 400, pr: 5 }} />
                    <TextField variant="filled"
                    {...register('seasonExternalId', { required: false })}
                    id="seasonExternalId"   name="seasonExternalId"  label="Season Id" aria-describedby="seasonExternalId_entry"
                    sx={{ width: 160, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('seasonNumberFrom', { required: false })}
                               id="seasonNumberFrom"   name="seasonNumberFrom"  label="# From" aria-describedby="seasonNumberFrom_entry"
                               sx={{ width: 120, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('seasonNumberTo', { required: false })}
                               id="seasonNumberTo"   name="seasonNumberTo"  label="# To" aria-describedby="seasonNumberTo_entry"
                               sx={{ width: 120, pr: 5 }} />
                    <TextField variant="filled"
                    {...register('seasonName', { required: false })}
                    id="seasonName"   name="seasonName"  label="Season Name" aria-describedby="seasonName_entry"
                    sx={{ width: 400 }} />
                    </Stack>
                    <Stack direction={"Horizontal"}  sx={{ pb: 1 }}>

                            <FormControl variant="standard" sx={{ ml: 1, pr: 5, minWidth: 300 }} >
                                <InputLabel sx={{ ml: 1}} htmlFor="m4mktGroup">Made-For Market Group</InputLabel>
                        <Select
                            {...register('m4mktGroup', { required: false })}
                            labelId="demo-simple-select-filled-m4mktGroup"
                            id="m4mktGroup"
                            FreeSolo={true}
                            variant="filled"
                            label="m4mktGroup"
                            value={selectedM4mktGroup}
                            onChange={handleM4mktGroupChange}
                            sx={{ width: 300}}
                        >

                            {m4mktGroupDropdown.map((m4mktGroupItem) =>
                                <MenuItem  FreeSolo={true} value={m4mktGroupItem.singleField}>{m4mktGroupItem.singleField}</MenuItem>
                            )}
                        </Select>
                            </FormControl>
                        <FormControl variant="standard" sx={{ pr: 5, minWidth: 300 }} >
                            <InputLabel sx={{ ml: 1}} htmlFor="initMkt">Initial Market</InputLabel>
                            <Select
                                {...register('initMkt', { required: false })}
                                labelId="demo-simple-select-filled-initMkt"
                                id="initMkt"
                                variant="filled"
                                label="initMkt"
                                value={selectedInitialMarket}
                                onChange={handleInitialMarketChange}
                                sx={{ width: 300}}
                            >
                                {initialMarketDropdown.map((initialMarketItem) =>
                                    <MenuItem  value={initialMarketItem.singleField}>{initialMarketItem.singleField}</MenuItem>
                                )}
                            </Select>
                        </FormControl>
                        {/*<Controller*/}
                        {/*    name="initMkt"*/}
                        {/*    control={control}*/}
                        {/*    defaultValue=""*/}
                        {/*    render={({ field }) => (*/}
                        {/*        <Select*/}
                        {/*            {...field}*/}
                        {/*            label="Initial Market"*/}
                        {/*            variant="filled"*/}
                        {/*            sx={{ width: 300 }}*/}
                        {/*        >*/}
                        {/*            {initialMarketDropdown.map((item) => (*/}
                        {/*                <MenuItem key={item.singleField} value={item.singleField}>*/}
                        {/*                    {item.singleField}*/}
                        {/*                </MenuItem>*/}
                        {/*            ))}*/}
                        {/*        </Select>*/}
                        {/*    )}*/}
                        {/*/>*/}
                        <FormControl variant="standard" sx={{ pr: 5, minWidth: 200 }} >
                            <InputLabel sx={{ ml: 1}} htmlFor="genre">Genre</InputLabel>
                            <Select
                                {...register('genre', { required: false })}
                                labelId="demo-simple-select-filled-genre"
                                id="genre"
                                FreeSolo={true}
                                variant="filled"
                                label="genre"
                                value={selectedGenre}
                                onChange={handleGenreChange}
                                sx={{ width: 200}}
                            >
                                {genreDropdown.map((genreItem) =>
                                    <MenuItem  FreeSolo={true} value={genreItem.singleField}>{genreItem.singleField}</MenuItem>
                                )}
                            </Select>
                        </FormControl>
                        <FormControl variant="standard" sx={{ pr: 5, minWidth: 200 }} >
                            <InputLabel sx={{ ml: 1}} htmlFor="productionType">Production Type</InputLabel>
                            <Select
                                {...register('productionType', { required: false })}
                                labelId="demo-simple-select-filled-productionType"
                                id="productionType"
                                FreeSolo={true}
                                variant="filled"
                                label="productionType"
                                value={selectedProductionType}
                                onChange={handleProductionTypeChange}
                                sx={{ width: 200}}
                            >
                                {productionTypeDropdown.map((productionTypeItem) =>
                                    <MenuItem  FreeSolo={true} value={productionTypeItem.singleField}>{productionTypeItem.singleField}</MenuItem>
                                )}
                            </Select>
                        </FormControl>
                        <TextField variant="filled"
                                   {...register('eidr', { required: false })}
                                   id="eidr"   name="eidr"  label="EIDR" aria-describedby="eidr_entry"
                                   sx={{ width: 250, pr: 5 }} />
                        </Stack>
                <Stack direction={"Horizontal"}  sx={{ pb: 2 }}>
                    <FormControl variant="standard" sx={{ pr: 5, minWidth: 200 }} >
                        <InputLabel sx={{ ml: 1}} htmlFor="coveredProduct">Covered Product</InputLabel>
                        <Select
                            {...register('coveredProduct', { required: false })}
                            labelId="demo-simple-select-filled-coveredProduct"
                            id="coveredProduct"
                            FreeSolo={true}
                            variant="filled"
                            label="coveredProduct"
                            value={selectedCoveredProduct}
                            onChange={handleCoveredProductChange}
                            sx={{ width: 200}}
                        >
                            {coveredProductDropdown.map((coveredProductItem) =>
                                <MenuItem  FreeSolo={true} value={coveredProductItem.name}>{coveredProductItem.name}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <FormControl variant="standard" sx={{ pr: 5, minWidth: 200 }} >
                        <InputLabel sx={{ ml: 1}} htmlFor="producer">Producer</InputLabel>
                        <Select
                            {...register('producer', { required: false })}
                            labelId="demo-simple-select-filled-producer"
                            id="producer"
                            FreeSolo={true}
                            variant="filled"
                            // value={selectedM4mktGroup}
                            label="producer"
                            value={selectedProducer}
                            onChange={handleProducerChange}
                            sx={{ width: 200}}
                        >
                            {producerDropdown.map((producerItem) =>
                                <MenuItem  FreeSolo={true} value={producerItem.singleField}>{producerItem.singleField}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <FormControl variant="standard" sx={{ pr: 5, minWidth: 200 }} >
                        <InputLabel sx={{ ml: 1}} htmlFor="financialCode">Financial Code</InputLabel>
                        <Select
                            {...register('financialCode', { required: false })}
                            labelId="demo-simple-select-filled-financialCode"
                            id="financialCode"
                            FreeSolo={true}
                            variant="filled"
                            value={selectedFinancialCode}
                            label="financialCode"
                            onChange={handleFinancialCodeChange}
                            sx={{ width: 200}}
                        >
                            {financialCodeDropdown.map((financialCodeItem) =>
                                <MenuItem  FreeSolo={true} value={financialCodeItem.singleField}>{financialCodeItem.singleField}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <FormControl variant="standard" sx={{ pr: 5, minWidth: 150 }} >
                        <InputLabel sx={{ ml: 1}} htmlFor="participations">Participations</InputLabel>
                        <Select
                            {...register('participations', { required: false })}
                            labelId="demo-simple-select-filled-participations"
                            id="participations"
                            FreeSolo={true}
                            variant="filled"
                            label="participations"
                            value={selectedParticipations}
                            onChange={handleParticipationsChange}
                            sx={{ width: 150}}
                        >
                            {setupsDropdown.map((setupsItem) =>
                                <MenuItem  FreeSolo={true} value={setupsItem}>{setupsItem}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <FormControl variant="standard" sx={{ pr: 5, minWidth: 150 }} >
                        <InputLabel sx={{ ml: 1}} htmlFor="residuals">Residuals</InputLabel>
                        <Select
                            {...register('residuals', { required: false })}
                            labelId="demo-simple-select-filled-residuals"
                            id="residuals"
                            FreeSolo={true}
                            variant="filled"
                            label="residuals"
                            value={selectedResiduals}
                            onChange={handleResidualsChange}
                            sx={{ width: 150}}
                        >
                            {setupsDropdown.map((setupsItem) =>
                                <MenuItem  FreeSolo={true} value={setupsItem}>{setupsItem}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <FormControl variant="standard" sx={{ pr: 5, minWidth: 150 }} >
                        <InputLabel sx={{ ml: 1}} htmlFor="royalties">Royalties</InputLabel>
                        <Select
                            {...register('royalties', { required: false })}
                            labelId="demo-simple-select-filled-royalties"
                            id="royalties"
                            FreeSolo={true}
                            variant="filled"
                            label="royalties"
                            value={selectedRoyalties}
                            onChange={handleRoyaltiesChange}
                            sx={{ width: 150}}
                        >
                            {setupsDropdown.map((setupsItem) =>
                                <MenuItem  FreeSolo={true} value={setupsItem}>{setupsItem}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <Button
                        type= "submit"
                    >RETRIEVE</Button>
                    <Button onClick={handleClear}
                    >CLEAR</Button>
                </Stack>

            </Box>
        </form>
    );

    return (
        <Box sx={{ position: 'relative' }}>
            {searchForm()}
            {selectorSubmitting && <CircularProgressOverlay/>}
        </Box>

    )


}

